import { validateFormField } from '../helper/helpers';

export default class ContactFormFactory {
  constructor() {
    const contactForms = document.querySelectorAll('.contact-form.brick');

    contactForms.forEach((contactForm) => new ContactForm(contactForm));
  }
}

/**
 * Basic validation of contact form.
 */
class ContactForm {
  constructor(root) {
    this.root = root;
    this.elsRequired = root.querySelectorAll('[required]');
    this.elSubmit = root.querySelector('[type="submit"]');

    if (!this.elsRequired.length || !this.elSubmit) {
      return;
    }

    this.validateAll();

    this.elsRequired.forEach((el) => {
      if (['text', 'email', 'textarea', 'number'].includes(el.type)) {
        el.addEventListener('input', () => this.validateAll());
      } else if (['checkbox'].includes(el.type)) {
        el.addEventListener('change', () => this.validateAll());
      }
    });
  }

  /**
   * Validates all required form-fields.
   */
  validateAll() {
    if (Array.from(this.elsRequired).some((el) => !validateFormField(el))) {
      this.root.classList.add('invalid');
      this.elSubmit.setAttribute('disabled', true);
    } else {
      this.root.classList.remove('invalid');
      this.elSubmit.removeAttribute('disabled');
    }
  }
}
